import React from 'react'
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

const RedirectComponent = (props) => {
    
    const [searchParams] = useSearchParams();
    const location = useLocation()
    
    if (searchParams.get('nanoid') && searchParams.get('visit') ){
        return <Navigate to={`/${searchParams.get('visit')}/home/${searchParams.get('nanoid')}`} />
    }
    if (searchParams.get('nanoid')){    
        return <Navigate to={`/share/${searchParams.get('nanoid')}`} />
    }else{
        if (location.pathname === "/otp")        
            return <Navigate to={`/${searchParams.get('visit')}/otp`} />           
        return <Navigate to={`/${searchParams.get('visit')}/FoodCoupon`} />    
    }
}

export default RedirectComponent